import React from 'react';

function Talks() {
  const talks = [
    {
      venue: 'Data Fusion',
      title: 'Графы в телеком-индустрии',
      url: 'https://vkvideo.ru/video-214144682_456239211?t=20m12s',
      action: 'Смотреть на VK Видео',
    },
    {
      venue: 'ByData',
      title: 'Машинное обучение на графах: подходы и перспективы',
      url: 'https://t.me/glotov_pro/105',
      action: 'Смотреть в Telegram',
    },
    {
      venue: 'Data Fest',
      title: 'Инженерия AI-команд',
      url: 'https://vkvideo.ru/video-164555658_456241376?t=8h6m16s',
      action: 'Смотреть на VK Видео',
      image: {
        src: '/data-fest.webp',
        alt: 'Алексей Глотов выступает на Data Fest',
      },
    },
    {
      venue: 'Концептуальный форум',
      title: 'Основы теории суперсистем',
      url: 'https://vkvideo.ru/video-210491290_456239068',
      action: 'Смотреть на VK Видео',
    },
    {
      venue: 'РБК Тренды',
      title: 'ИИ против телефонного мошенничества',
      url: 'https://trends.rbc.ru/trends/industry/cmrm/655474e29a7947cf9012dc9a',
      action: 'Читать интервью',
    },
    {
      venue: 'РБК ТВ — прямой эфир',
      title: 'Борьба с телефонным мошенничеством',
      url: 'https://tv.rbc.ru/archive/chez/6695553b2ae5968508538a90',
      action: 'Смотреть эфир',
    },
  ];

  return (
    <section id="talks" className="section talks-section">
      <div className="section-heading">
        <p className="eyebrow">04 / Выступления</p>
        <h2>Доклады и медиа</h2>
      </div>
      <div className="talks-grid">
        {talks.map((talk) => (
          <article className="talk-card" key={talk.title}>
            {talk.image && (
              <figure>
                <img src={talk.image.src} alt={talk.image.alt} loading="lazy" />
              </figure>
            )}
            <div className="talk-body">
              <span className="block-tag">{talk.venue}</span>
              <h3>{talk.title}</h3>
              <a
                className="talk-link"
                href={talk.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {talk.action}
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Talks;
